import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-valuenow"];
import { computed } from 'vue';
import { useNavigationProgress } from '@/composables/useNavigationProgress.js';
export default {
  __name: 'NavigationProgressBar',
  setup(__props) {
    const {
      progress,
      visible,
      percent
    } = useNavigationProgress();
    const barScale = computed(() => Math.max(0, Math.min(1, progress.value)));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["nav-progress", {
          'is-visible': _unref(visible)
        }]),
        role: "progressbar",
        "aria-valuenow": _unref(percent),
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-hidden": "true"
      }, [_createElementVNode("div", {
        class: "nav-progress__bar",
        style: _normalizeStyle({
          transform: `scaleX(${barScale.value})`
        })
      }, null, 4)], 10, _hoisted_1);
    };
  }
};